;(function () {
  let articleCardTemplate = `
        <article class="tw-py-6 md:tw-py-10 first-of-type:tw-pt-0 tw-border-b-[1px] tw-border-black tw-border-solid">
            <a :href="article.url" class="tw-no-underline tw-text-inherit">
                <div class="tw-grid tw-grid-cols-3 tw-gap-4 md:tw-grid-cols-6 md:tw-gap-24">
                    <div class="tw-col-span-2 md:tw-col-span-3 tw-flex tw-flex-col tw-justify-between">
                    <div>
                        <div class="tags tw-flex tw-flex-wrap tw-gap-3 tw-mb-4" v-if="article.tags && article.tags.trim() !== ''">
                            <div
                                class="tw-flex"
                                v-for="tag in article.tags.split(',').map(tag => tag.trim())"
                                :key="tag"
                            >
                                <!-- Exclude the "top-pick-article" tag -->
                                <span v-if="tag !== 'top-pick-article'" class="tw-rounded-sm tw-mr-2 tw-text-[12px] tw-border-[1px] tw-border-solid tw-border-black tw-py-1 tw-px-3">
                                    {{ tag }}
                                </span>
                            </div>
                        </div>
                        <h3 class="tw-text-[21px] md:tw-text-[28px] tw-leading-6 md:tw-leading-8 tw-tracking-normal tw-font-light tw-pb-8 tw-font-semibold tw-text-4xl">{{ article.title }}</h3>
                    </div>
                    <p v-if="article.subTitle !== ''" class="article-subtitle tw-text-[18px] tw-tracking-normal tw-font-light">{{ article.subTitle }}</p>
                    </div>
                    <div class="tw-col-span-1 md:tw-col-span-3">
                        <div class="tw-relative tw-h-[150px] md:tw-h-[400px]">
                            <img :src="imgSrc" :alt="article.title" :title="article.title" class="tw-w-full tw-h-full tw-object-cover tw-rounded-md">
                        </div>                        
                    </div>
                </div>
            </a>
        </article>
    `.trim()

  Vue.component('article-card', {
    props: {
      article: {
        type: Object,
        required: true,
      },
    },
    computed: {
      // Article preview image
      imgSrc: function () {
        // Log the properties of the article object
        let imgSrc = {}

        if (this.background !== null) {
          imgSrc = `${this.article.previewImage}`
        }

        return imgSrc
      },
    },
    template: articleCardTemplate,
  })

  let topPickArticles = `
    <article>
        <a :href="article.url" class="tw-no-underline tw-text-inherit">
            <div class="tw-grid tw-grid-cols-3 tw-gap-8 tw-py-8">
                <div class="tw-col-span-2">
                <div class="tags tw-flex tw-mb-4 tw-flex-wrap tw-gap-2" v-if="article.tags && article.tags.trim() !== ''">
                    <div
                        v-for="tag in article.tags.split(',').map(tag => tag.trim())"
                        :key="tag"
                        class="tw-flex tw-flex-wrap"
                        v-if="tag !== 'top-pick-article'"
                    >
                        <!-- Exclude the "top-pick-article" tag -->
                        <span class="tw-rounded-sm tw-mr-2 tw-text-[12px] tw-border-[1px] tw-border-solid tw-border-black tw-py-1 tw-px-3">
                            {{ tag }}
                        </span>
                    </div>
                </div>
                    <h3 class="tw-text-[18px] md:tw-text-[20px] tw-leading-6 tw-tracking-normal tw-font-light tw-font-semibold tw-text-4xl">{{ article.title }}</h3>
                </div>
                <div class="tw-col-span-1">
                    <div class="tw-relative tw-h-[120px]">
                        <img :src="imgSrc" :alt="article.title" :title="article.title" class="tw-w-full tw-h-full tw-object-cover tw-rounded-md">
                    </div>                        
                </div>
            </div>
        </a>
    </article>
    `.trim()

  Vue.component('top-article-card', {
    props: {
      article: {
        type: Object,
        required: true,
      },
    },
    computed: {
      // Article preview image
      imgSrc: function () {
        // Log the properties of the article object
        let imgSrc = {}

        if (this.background !== null) {
          imgSrc = `${this.article.previewImage}`
        }

        return imgSrc
      },
    },
    template: topPickArticles,
  })

  let mainArticleCardTemplate = `
        <article class="article-card-long">
            <div class="article-card-long__image">
                <div class="article-card-long__image-inner" :style="styles"></div>
            </div>
    
            <div class="article-card-long__content" :style="contentStyles">
                <h3 class="article-card-long__title" data-keyword>
                    <a :href="article.url">
                        <span class="article-card-long__title-icon" data-icon></span>{{ article.title }}
                    </a>
                </h3>
    
                <div class="article-card-long__text" v-html="article.excerpt"></div>
            </div>
        </article>
    `.trim()

  Vue.component('main-article-card', {
    props: {
      article: {
        type: Object,
        required: true,
      },
      bgColor: {
        type: String,
        required: true,
      },
    },
    computed: {
      styles: function () {
        let styles = {}

        if (this.article.bigImage !== null) {
          styles['background-image'] = `url("${this.article.bigImage}")`
        }

        return styles
      },
      contentStyles: function () {
        let styles = {}

        if (this.bgColor !== null) {
          styles['background-color'] = this.bgColor
        }

        return styles
      },
    },
    filters: {
      truncateWords: function (value) {
        if (!value) {
          return ''
        }

        value = value.split(' ', 15).join(' ')
        return value
      },
    },
    template: mainArticleCardTemplate,
  })

  let tagTemplate = `
        <li class="tw-flex tw-group aria-hidden:tw-hidden" :class="classes" aria-hidden="true">
            <a
              href="/blogs/all"
              role="button"
              class="tw-flex tw-capitalize tw-cursor-pointer tw-text-sm/none tw-whitespace-nowrap tw-text-nowrap tw-no-underline tw-font-normal tw-py-2 tw-px-4 tw-border tw-border-solid tw-border-[#DCDCDA] tw-rounded-full tw-text-center tw-bg-white tw-text-primary hover:tw-bg-black hover:tw-text-white group-[.tag--active]:!tw-bg-black group-[.tag--active]:!tw-text-white"
              @click="toogleActive"
              >
                {{ tag }}
            </a>
        </li>
    `.trim()

  Vue.component('tag', {
    props: {
      tag: {
        type: String,
        required: true,
      },
      active: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      toogleActive: function (e) {
        e.preventDefault()
        this.$emit('tags-update', {
          tagName: this.tag,
        })
      },
      removeNumberFromTag: function (tag) {
        return tag.includes('-') ? tag.split('-')[0] : tag
      },
    },

    computed: {
      classes: function () {
        let classes = {}

        let formattedTag = this.tag.trim().toLowerCase().replace(/\s+/g, '-')
        const { searchParams } = new URL(window.location.href)
        const currentSearchParam = searchParams.get('sub-filter')

        if (this.active || this.$parent.activeTags.includes(formattedTag)) {
          classes['tag--active'] = true
        }

        if (currentSearchParam) {
          this.$parent.activeTags[0] = currentSearchParam
          if (
            this.$el &&
            this.$el.ariaHidden === 'false' &&
            formattedTag.includes(this.$parent.activeTags[0]) &&
            this.tag === this.$el.dataset.name
          ) {
            const categoryTag = document.querySelector('.js-current-category-tag')
            classes['tag--active'] = true
            categoryTag.classList.remove('tag--active')
          }
        }

        return classes
      },
    },
    mounted: function () {
      const { pathname } = new URL(window.location.href)
      const subPaths = pathname.replace('/blogs/', '').split('/')
      const mainCategory = subPaths[0].replaceAll('-', ' ')
      const subCategory = subPaths[subPaths.length - 1].replaceAll('-', ' ')

      for ([mainKey, mainValue] of Object.entries(nestedCategories)) {
        if (mainValue.name === this.tag) {
          this.$el.setAttribute('data-parent', mainValue.parent)
          this.$el.firstElementChild.href = `/blogs/${this.removeNumberFromTag(mainValue.name)
            .toLowerCase()
            .replaceAll(' ', '-')}`
          if (mainValue.parent === mainCategory) this.$el.ariaHidden = 'false'
        }

        if (mainValue.children.length > 0) {
          for (let child of mainValue.children) {
            if (child.name === this.tag) {
              this.$el.setAttribute('data-parent', child.parent)
              this.$el.setAttribute('data-url', child.url)
              this.$el.setAttribute('data-name', child.name)
              this.$el.firstElementChild.href = `/blogs/${this.removeNumberFromTag(child.parent)
                .toLowerCase()
                .replaceAll(' ', '-')}/tagged/${this.removeNumberFromTag(child.name).toLowerCase().replaceAll(' ', '-')}`
              if (mainCategory === child.parent && subPaths.length === 1) {
                this.$el.ariaHidden = 'false'
              }
              continue
            }
            if (child.children.length > 0) {
              for (let subChild of child.children) {
                if (subChild.name === this.tag) {
                  this.$el.setAttribute('data-name', this.tag)
                  this.$el.setAttribute('data-parent', subChild.parent)
                  this.$el.firstElementChild.href = `/blogs/${this.removeNumberFromTag(child.parent)
                    .toLowerCase()
                    .replaceAll(' ', '-')}/tagged/${this.removeNumberFromTag(subChild.parent)
                    .toLowerCase()
                    .replaceAll(' ', '-')}?sub-filter=${this.removeNumberFromTag(subChild.name)
                    .toLowerCase()
                    .replaceAll(' ', '-')}`
                  if (subCategory === subChild.parent.toLowerCase() && subPaths.length > 2) {
                    this.$el.ariaHidden = 'false'
                  }
                }
              }
            }
          }
        }
      }

      this.$el.firstElementChild.textContent = this.removeNumberFromTag(this.tag)
      this.$el.firstElementChild.ariaLabel = `Filter by ${this.removeNumberFromTag(this.tag)} tag`
    },
    template: tagTemplate,
  })

  let blogSection = `
        <div class="tw-mb-[120px] js-animate animate-fade-in" data-offset="200" v-if="blog.articles.length">

            <h2 class="tw-mb-4 md:tw-mb-10 tw-border-b-[1px] tw-border-solid tw-text-[36px] md:tw-text-[70px] tw-leading-none tw-tracking-normal tw-font-light tw-pb-8">
            {{ processedBlogTitle }}

            </h2>

            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-5 tw-gap-12 tw-mb-5 md:tw-mb-10">
                <div class="tw-col-span-3 main-articles-wrapper" v-if="restArticles.length"> 
                    <article-card :article="article"v-for="(article, index) in restArticles" :key="index" />
                    <div v-if="canLoadMoreRestArticles">
                        <button @click="loadMoreArticles" class="tw-btn-secondary tw-mt-10">Load More</button>
                    </div>
                 </div>
            <div class="tw-col-span-3 md:tw-col-span-2" v-if="featuredArticles.length">
                <div class="tw-bg-white tw-rounded-md tw-pt-4 tw-px-8 remove-border-bottom-last">
                    <h2 class="tw-border-b-[1px] tw-border-solid tw-text-[26px] md:tw-text-[30px] tw-leading-none tw-tracking-normal tw-font-light tw-pb-5 tw-pt-5">
                        Featured
                    </h2>
                    <div v-for="(article, index) in featuredArticles" :key="index" class="tw-border-b-[1px] tw-border-black tw-border-solid last-of-type:tw-border-b-0">
                        <top-article-card :article="article" />
                    </div>
                </div>
            </div>
    </div>

        
        </div>
    `.trim()

  Vue.component('blog-section', {
    props: {
      blog: {
        type: Object,
        required: true,
      },
    },
    data: function () {
      return {
        page: 1,
        articlesToShow: 4, // Number of articles to display initially
        articlesToLoad: 8, // Number of articles to load on "Load More" click
        featuredArticlesToShow: 6,
      }
    },
    computed: {
      classes: function () {
        let classes = {}

        if (this.active) {
          classes['tag--active'] = true
        }

        return classes
      },
      restArticles: function () {
        return this.blog.articles.slice(0, this.articlesToShow)
      },
      canLoadMoreRestArticles: function () {
        return this.articlesToShow < this.blog.articles.length
      },
      featuredArticles: function () {
        return this.blog.articles
          .filter((article) => article.tags.includes('top-pick-article'))
          .slice(0, this.featuredArticlesToShow)
      },
      processedBlogTitle() {
        return this.blog.title.replace(/&#39;/g, '’')
      },
    },
    methods: {
      loadMoreArticles: function () {
        this.articlesToShow += this.articlesToLoad
      },
    },
    template: blogSection,
  })

  let app = new Vue({
    el: '#blogs-list',
    data: function () {
      return Object.assign(
        {},
        {
          activeBlog: null,
          activeTags: [],
          searchQuery: '',
          showMessageForEmptyFilters: false,
        },
        window.blogsListData
      )
    },
    mounted: function () {
      let path = window.location.pathname
      const currentUrl = new URL(window.location.href)
      const currentSubFilter = currentUrl.searchParams.get('sub-filter')
      const blogBreadcrumbs = document.querySelectorAll('.js-blog-breadcrumb')

      if (currentSubFilter) {
        const lastBreadcrumb = blogBreadcrumbs[blogBreadcrumbs.length - 1]
        lastBreadcrumb.ariaHidden = 'false'
        const link = lastBreadcrumb.querySelector('a')

        link.href = `${path}${currentUrl.search}`
        link.textContent =
          currentSubFilter.length < 4 ? currentSubFilter.toUpperCase() : currentSubFilter.replaceAll('-', ' ')
      } else if (!currentUrl.pathname.includes('blogs/all')) {
        blogBreadcrumbs.forEach((breadcrumb, idx) => {
          if (breadcrumb.ariaHidden === 'true') {
            const lastVisibleBreadcrumbDividers = blogBreadcrumbs[idx - 1].querySelectorAll('span')
            lastVisibleBreadcrumbDividers[lastVisibleBreadcrumbDividers.length - 1].ariaHidden = 'true'
          }
        })
      }

      if (path.endsWith('/')) {
        path = path.slice(0, -1)
      }
      path.replace('/blogs/')
      let segments = path.split('/')
      let activeHandle = segments[segments.length - 1]

      if (activeHandle) {
        let formattedHandle = activeHandle.trim().toLowerCase().replace(/\s+/g, '-')

        if (this.blogs[formattedHandle]) {
          this.activeTags = [formattedHandle]
          this.activeBlog = this.blogs[formattedHandle]
        } else {
          for ([mainKey, mainValue] of Object.entries(nestedCategories)) {
            if (mainValue.children.length > 0) {
              mainValue.children.forEach((child) => {
                formattedHandle = child.name.trim().toLowerCase().replace(/\s+/g, '-')
                if (formattedHandle === activeHandle) {
                  formattedHandle = child.parent.trim().toLowerCase().replace(/\s+/g, '-')
                  this.activeTags = [formattedHandle]
                  this.activeBlog = this.blogs[formattedHandle]
                  this.resetFilter(child.name)
                }
              })
            }
          }
        }
      }

      if (typeof window.animateElementsOnScroll !== 'undefined') {
        window.animateElementsOnScroll()
      }

      if (typeof window.addIcons !== 'undefined') {
        window.addIcons()
      }
      if (!window.onpopstate) {
        window.onpopstate = (e) => {
          this.updateTags({ tagName: e.state }, true)
        }
      }
      window.addEventListener('pushstate', this.updateBreadcrumbs)
      window.addEventListener('pushstate', this.updateCategoryHref)
    },
    updated: function () {
      window.animateElementsOnScroll()
      window.addIcons()
    },
    methods: {
      updateCategoryHref: function () {
        const mainTag = document.querySelector('.js-current-main-tag')
        const categoryTag = document.querySelector('.js-current-category-tag')

        const { pathname } = new URL(window.location.href)
        const subPaths = pathname.replace('/blogs/', '').split('/')

        categoryTag.href = pathname
        mainTag.href = `/blogs/${subPaths.length === 1 ? 'all' : subPaths[0]}`
      },
      updateBreadcrumbs: function () {
        const currentUrl = new URL(window.location.href)
        const blogBreadcrumbs = document.querySelectorAll('.js-blog-breadcrumb')
        const currentSubFilter = currentUrl.searchParams.get('sub-filter')
        const formattedPaths = currentUrl.pathname
          .replace('/blogs', '')
          .replace('/all', '')
          .replace('/tagged', '')
          .split('/')
          .filter((path) => path[0])

        blogBreadcrumbs.forEach((breadcrumb) => (breadcrumb.ariaHidden = 'true'))
        if (currentSubFilter) formattedPaths.push(currentSubFilter)

        for (let idx = 0; idx < formattedPaths.length; idx++) {
          const link = blogBreadcrumbs[idx].querySelector('a')
          const linkDividers = blogBreadcrumbs[idx].querySelectorAll('span')

          blogBreadcrumbs[idx].ariaHidden = 'false'
          if (linkDividers.length) {
            linkDividers[linkDividers.length - 1].ariaHidden = `${idx === formattedPaths.length - 1 ? 'true' : 'false'}`
          }

          link.textContent =
            formattedPaths[idx].length < 4 ? formattedPaths[idx].toUpperCase() : formattedPaths[idx].replaceAll('-', ' ')

          if (idx === 0) {
            link.href = `/blogs/${formattedPaths[0]}`
          } else if (idx === 1) {
            link.href = formattedPaths[1]
          } else if (idx === 2) {
            link.href = `${formattedPaths[1]}?sub-filter=${formattedPaths[2]}`
          }
        }
      },
      resetFilter: function (forceActiveTag) {
        this.activeTags.shift()
        if (forceActiveTag) this.activeTags[0] = forceActiveTag
      },
      updateFilterTags: function (parent) {
        const tagElements = document.getElementById('tags-container').querySelectorAll('li')
        tagElements.forEach((tagElement) => {
          tagElement.ariaHidden = `${tagElement.dataset.parent.toLowerCase() === parent.toLowerCase() ? 'false' : 'true'}`
          tagElement.classList.remove('tag--active')
        })
      },
      goBack: function (e) {
        e.preventDefault()
        const tagClicked = e.target.closest('a')
        const { pathname } = new URL(window.location.href)
        const subPaths = pathname.replace('/blogs/', '').split('/')

        if (tagClicked.classList.contains('js-current-category-tag')) {
          window.history.pushState({}, '', `/blogs/${subPaths.join('/')}`)
          window.dispatchEvent(new Event('pushstate'))
          this.updateFilterTags(subPaths[subPaths.length - 1].replaceAll('-', ' '))
          tagClicked.classList.add('tag--active')
          this.resetFilter(subPaths[subPaths.length - 1])
        } else {
          const mainTag = document.querySelector('.js-current-main-tag')
          const categoryTag = document.querySelector('.js-current-category-tag')
          if (subPaths.length === 1) {
            window.history.pushState({}, '', 'all')
            window.dispatchEvent(new Event('pushstate'))
            this.updateFilterTags('all')
            categoryTag.ariaHidden = 'true'
            mainTag.classList.add('tag--active')
            this.resetFilter()
          } else {
            window.history.pushState({}, '', `/blogs/${subPaths[0]}`)
            window.dispatchEvent(new Event('pushstate'))
            this.updateFilterTags(subPaths[0].replaceAll('-', ' '))
            categoryTag.firstElementChild.textContent = `All ${subPaths[0].replaceAll('-', ' ')}`
            categoryTag.classList.add('tag--active')
            mainTag.firstElementChild.textContent = `All Articles`
            this.resetFilter(subPaths[0])
          }
        }
      },
      updateTags: function (payload, isForced = false) {
        const { pathname } = new URL(window.location.href)
        const subPaths = pathname.replace('/blogs/', '').split('/')
        const mainTag = document.querySelector('.js-current-main-tag')
        const categoryTag = document.querySelector('.js-current-category-tag')

        let tagName = payload.tagName.trim().toLowerCase().replace(/\d+/g, '').replace(/\s+/g, '-')
        this.activeTags = [tagName]
        let activeBlog = this.blogs[tagName]
        if (activeBlog) {
          if (!isForced) {
            window.history.pushState(tagName, '', activeBlog.url)
            window.dispatchEvent(new Event('pushstate'))
          }

          categoryTag.ariaHidden = 'false'
          categoryTag.classList.add('tag--active')
          mainTag.classList.remove('tag--active')
          categoryTag.firstElementChild.textContent = `All ${payload.tagName.replace(/\d+/g, '')}`
          this.updateFilterTags(payload.tagName)
        } else {
          const tagElements = document.getElementById('tags-container').querySelectorAll('li')
          let targetTag

          tagElements.forEach((tag) => {
            const name = tag.dataset?.name
            if (name === payload.tagName) targetTag = tag
          })

          let targetPath = targetTag?.dataset?.url
          if (targetPath && !isForced) {
            if (targetPath === '#') {
              targetPath = `${subPaths[0]}/tagged/${tagName}`
            }
            window.history.pushState(tagName, '', `/blogs${targetPath}`)
            window.dispatchEvent(new Event('pushstate'))
            categoryTag.ariaHidden = 'false'
            categoryTag.classList.add('tag--active')
            categoryTag.firstElementChild.textContent = `All ${payload.tagName.replace(/\d+/g, '').replaceAll('-', ' ')}`
            mainTag.firstElementChild.textContent = `All ${subPaths[0].replaceAll('-', ' ')}`
            mainTag.classList.remove('tag--active')
            this.updateFilterTags(payload.tagName)
          } else {
            let splitSearchParam = tagName.split('-')
            if (splitSearchParam[splitSearchParam.length - 1] === '') {
              splitSearchParam.pop()
              tagName = splitSearchParam.join('-')
            }
            categoryTag.classList.remove('tag--active')
            window.history.pushState(tagName, '', `${pathname}?sub-filter=${tagName.split('-').join('-')}`)
            window.dispatchEvent(new Event('pushstate'))
          }
        }
      },
      filterArticles: function (blog) {
        const { pathname } = new URL(window.location.href)
        const subPaths = pathname.replace('/blogs/', '').split('/')
        const nestedTarget = nestedCategories[subPaths[0].replaceAll('-', ' ')]?.children.find(
          (child) => child.name.toLowerCase().replaceAll(' ', '-') === subPaths[subPaths.length - 1]
        )
        let filteredArticles = []

        for (let article of blog.articles) {
          let showArticle = false
          if (nestedTarget) {
            if (
              article.url.includes(nestedTarget.parent.replaceAll(' ', '-')) &&
              article.tags.toLowerCase().replaceAll("'", '').includes(nestedTarget.name.toLowerCase()) &&
              article.tags[0]
            ) {
              showArticle = this.articleHasTags(article)
            }
          } else {
            showArticle = this.articleHasTags(article)
          }

          if (showArticle) filteredArticles.push(article)
        }

        return filteredArticles
      },
      articleHasTags: function (article) {
        const tags = article.tags.split(', ')
        const { pathname, searchParams } = new URL(window.location.href)
        const subPaths = pathname.replace('/blogs/', '').split('/')
        const target = nestedCategories[subPaths[0].replaceAll('-', ' ')]?.children.find(
          (child) => child.name.toLowerCase().replaceAll(' ', '-') === subPaths[subPaths.length - 1]
        )

        if (target) {
          for (let articleTag of tags) {
            const formattedTag = articleTag.toLowerCase().replaceAll("'", '')
            const currentSubFilter = searchParams.get('sub-filter')

            if (currentSubFilter) {
              if (currentSubFilter.replaceAll('-', ' ') === formattedTag) {
                return true
              }
            } else {
              if (
                target?.name.toLowerCase() === formattedTag &&
                article?.url.includes(target?.parent.replaceAll(' ', '-'))
              ) {
                return true
              }
            }
          }
        } else {
          let articleTags = article.url.split('/')
          for (let tag of this.activeTags) {
            let temp = tag.replaceAll(' ', '-')
            if (temp === '') {
              continue
            }

            if (articleTags.includes(temp)) {
              return true
            }
          }
        }

        return false
      },
      articlesLoaded: function (data) {
        let blogs = Object.assign({}, this.blogs)
        let blog = blogs[data.handle]

        let articles = blog.articles
        articles = articles.concat(data.articles)
        blog.articles = articles
        blog.postsToShow += 6

        this.blogs = blogs
      },
      search: function (event) {
        if (this.searchQuery.trim() === '') {
          event.preventDefault()
        }
      },
    },
    computed: {
      filteredBlogs: function () {
        let blogs = Object.assign({}, this.blogs)

        if (this.activeTags.length === 0) {
          // No tags are selected, use the initial articlesToShow value
          for (let handle in blogs) {
            blogs[handle].postsToShow = this.articlesToShow
          }
          return blogs
        }

        blogs = {}

        for (let handle in this.blogs) {
          let blog = Object.assign({}, this.blogs[handle])

          let filteredArticles = this.filterArticles(blog)

          if (filteredArticles.length > 0) {
            blog.articles_count = filteredArticles.length
            blog.postsToShow = filteredArticles.length
            blogs[handle] = blog
            blogs[handle].articles = filteredArticles
          }
        }

        if (Object.getOwnPropertyNames(blogs).length > 0) {
          this.showMessageForEmptyFilters = false
        } else {
          this.showMessageForEmptyFilters = true
        }

        return blogs
      },
    },
  })
})()
